// ElementControl 返回元素控制配置信息
// 参数  name 元素自定义标识（用于匹配对应配置信息）
// 返回值 配置信息
function ElementControl(name) {
    let elementInfo = [];
    if(sessionStorage.getItem('elementsInfo')&&sessionStorage.getItem('elementsInfo')!=undefined) {
        elementInfo = JSON.parse(sessionStorage.getItem('elementsInfo'));
    }
    let val = '';
    if(elementInfo.length > 0) {
        elementInfo.some(item => {
            if(item.elecustomuid == name) {
                val = item.val!==null?item.val:item.defeleval;
                return true;
            }
        })
    }
    return val;
}
export {
    ElementControl
}


// WEBPACK FOOTER //
// ./src/util/ElementControl.js